import request from '@/utils/request'
//查询文章分类
export function getArticleType(params) {
  return request({
    url: "/appConfig/findArticleCategory",
    method: "get",
    data:params
  })
}

//网站文章列表-分页查询
export function getListArticle(params) {
  return request({
    url: "/appConfig/listArticle",
    method: "get",
    data:params
  })
}

//网站协议查询
export function getBySpmkey(params) {
  return request({
    url: "/appConfig/getBySpmkey",
    method: "get",
    data:params
  })
}

//广告内容查询
export function getBanners(params) {
  return request({
    url: "/appConfig/getByAdkey",
    method: "get",
    data:params
  })
}



// WEBPACK FOOTER //
// ./src/api/homeApi.js